"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@material-ui/icons");
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var lab_1 = require("@material-ui/lab");
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var fieldsProps_1 = require("./utils/fieldsProps");
var StyledPaper = styled_components_1.default(core_1.Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 350px;\n"], ["\n    width: 350px;\n"])));
var StyledCheckbox = styles_1.withTheme(styled_components_1.default(core_1.Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        &.MuiCheckbox-colorPrimary {\n            padding: 0;\n        }\n    "], ["\n        &.MuiCheckbox-colorPrimary {\n            padding: 0;\n        }\n    "]))));
function TTableFilters(props) {
    var headerGroups = props.headerGroups, setAllFilters = props.setAllFilters, selectedColumnsWithFilters = props.selectedColumnsWithFilters, setSelectedColumnsWithFilter = props.setSelectedColumnsWithFilter, resetHiddenFilters = props.resetHiddenFilters;
    var _a = react_1.default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClick = react_1.useCallback(function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }, [anchorEl, setAnchorEl]);
    var handleClose = react_1.useCallback(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    var columns = headerGroups.flatMap(function (_) { return _.headers; });
    var colsWithFilter = headerGroups.flatMap(function (_) { return _.headers; }).filter(function (_) { return _.canFilter; });
    var colsWithFilterValue = colsWithFilter.filter(function (_) { return _.filterValue; });
    var viewableSelectedColWithFilter = colsWithFilter.filter(function (c) { return selectedColumnsWithFilters.includes(c.id); });
    var columnWithFilterValueButNotSelected = react_1.useMemo(function () { return colsWithFilterValue.filter(function (c) { return !viewableSelectedColWithFilter.map(function (sc) { return sc.id; }).includes(c.id); }); }, [colsWithFilterValue, viewableSelectedColWithFilter]);
    react_1.useEffect(function () {
        if (columnWithFilterValueButNotSelected.length) {
            setSelectedColumnsWithFilter(function (sCols) { return sCols.concat(columnWithFilterValueButNotSelected.map(function (_) { return _.id; })); });
        }
    }, [setSelectedColumnsWithFilter, columnWithFilterValueButNotSelected]);
    var handleChangeSelectedFilters = react_1.useCallback(function (event, newCols) {
        var newColIds = newCols.map(function (_) { return _.id; });
        setSelectedColumnsWithFilter(newColIds);
        resetHiddenFilters(newColIds);
    }, [setSelectedColumnsWithFilter, resetHiddenFilters]);
    var getOptionLabel = react_1.useCallback(function (p) { return p.Header; }, []);
    var getOptionSelected = react_1.useCallback(function (o, v) { return o.id === v.id; }, []);
    var intl = react_intl_1.useIntl();
    var byDefaultMessage = react_1.useMemo(function () { return intl.formatMessage({ id: 'ttable.byDefault', defaultMessage: 'По умолчанию' }); }, [intl]);
    var filterIsEmpty = selectedColumnsWithFilters.length < 1;
    var renderInput = react_1.useCallback(function (params) { return (react_1.default.createElement(core_1.TextField, __assign({}, params, { placeholder: filterIsEmpty ? byDefaultMessage : '' }, fieldsProps_1.textFieldProps))); }, [filterIsEmpty, byDefaultMessage]);
    var renderOption = react_1.useCallback(function (p, state) { return (react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(StyledCheckbox, { color: "primary", checked: state.selected })),
            react_1.default.createElement(core_1.Grid, { item: true }, p.Header)))); }, []);
    var resetAllFilters = react_1.useCallback(function () { return setAllFilters([]); }, [setAllFilters]);
    var selectedColumnsWithFilters1 = columns.filter(function (c) { return selectedColumnsWithFilters.includes(c.id); });
    return (react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Link, { onClick: handleClick },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440" })),
            react_1.default.createElement(core_1.Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } },
                react_1.default.createElement(StyledPaper, null,
                    react_1.default.createElement(core_1.Box, { padding: 3 },
                        react_1.default.createElement(lab_1.Autocomplete, { multiple: true, popupIcon: react_1.default.createElement(ExpandMore_1.default, null), noOptionsText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.resultsOption", defaultMessage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }), ChipProps: {
                                deleteIcon: react_1.default.createElement(icons_1.Clear, null),
                                size: 'small',
                                style: {
                                    maxWidth: 200,
                                },
                            }, clearText: "", closeText: "", openText: "", value: selectedColumnsWithFilters1, options: colsWithFilter, onChange: handleChangeSelectedFilters, getOptionLabel: getOptionLabel, getOptionSelected: getOptionSelected, renderInput: renderInput, renderOption: renderOption })),
                    react_1.default.createElement(core_1.Divider, null),
                    selectedColumnsWithFilters1.length ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.Box, { padding: 3 },
                            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", spacing: 2 }, selectedColumnsWithFilters1.map(function (c) { return (react_1.default.createElement(core_1.Grid, { key: c.id, xl: true, item: true }, c.render('Filter'))); }))),
                        react_1.default.createElement(core_1.Divider, null))) : null,
                    react_1.default.createElement(core_1.Box, { padding: 3 },
                        react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "center", alignItems: "center" },
                            react_1.default.createElement(core_1.Link, { onClick: resetAllFilters },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.clearAll", defaultMessage: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0451" })))))))));
}
exports.default = TTableFilters;
var templateObject_1, templateObject_2;
